import React from 'react';
import classNames from 'classnames';
import defaultTheme from '../../themes/default';

const Input = React.forwardRef(
  (
    {
      tag = 'input',
      type = 'text',
      variant = 'fill',
      appearance = 'primary',
      id,
      placeholder,
      value,
      onChange,
      touched,
      error,
      className,
    },
    ref,
  ) => {
    const Tag = tag;
    const classname = classNames(
      defaultTheme.input.base,
      defaultTheme.input[variant][appearance],
      className,
    );
    const conditionalProps =
      Tag === 'input'
        ? {}
        : {
            autoFormat: true,
            specialLabel: null,
            inputClass: classname,
            disableCountryCode: true,
            country: 'us',
            regions: 'north-america',
            enableAreaCodes: true,
          };

    return (
      <>
        <Tag
          ref={ref}
          type={type}
          id={id}
          placeholder={placeholder}
          value={value}
          onChange={onChange(id)}
          className={classname}
          {...conditionalProps}
        />
        {touched && error ? (
          <div className="absolute font-montserrat font-bold text-xs text-enterpriseOrange-500 px-4.5">
            {error}
          </div>
        ) : null}
      </>
    );
  },
);

export default Input;
